import { render, staticRenderFns } from "./ParoTipos.vue?vue&type=template&id=5334dcb0&"
import script from "./ParoTipos.vue?vue&type=script&lang=js&"
export * from "./ParoTipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports